import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import errorBoundary from '@ifeng-fe/errorBoundary';
import transform from 'chipDataTransform';

import HeadPoster from './headPoster';

import Content from './content';

import Footer from './footer';

import ChipsBox from '../components/chips';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        /**
         * 组件分发数据
         */
        const {
            onlineArea,
            headPoster,
            tabs,
            information,
            homeAd,
            meishiMap,
            thanksFor,
            footer,
            rule,
            judgesByArea,
            judges,
            manOfTheYear,
            rankingNav,
            rankingList,
            newsData,
            posters,
        } = this.props.content;

        return (
            <div className={styles.layout}>
                <HeadPoster content={{ headPoster }} />
                <div className={styles.content}>
                    <div className={styles.container}>
                        <Content
                            content={{
                                onlineArea,
                                tabs,
                                information,
                                homeAd,
                                meishiMap,
                                thanksFor,
                                rule,
                                judgesByArea,
                                judges,
                                manOfTheYear,
                                rankingNav,
                                rankingList,
                                newsData,
                                posters,
                            }}
                        />
                        <Footer content={footer} />
                    </div>
                </div>
                <ChipsBox content={{ headPoster }} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
